import { ARCHIVE_CACHE_HEADERS } from "@/lib/ssrCache";
import { createFileRoute } from "@tanstack/react-router";
import BrowseArchive from "@/components/BrowseArchive";
import { fetchBrowseEntries } from "@/lib/browseIndex";

export const Route = createFileRoute("/browse/$page")({
  loader: async () => await fetchBrowseEntries(),
  headers: () => ARCHIVE_CACHE_HEADERS,
  head: ({ params }) => {
    const page = params.page;
    return {
      meta: [
        { property: "og:url", content: `https://www.garden-review.co.uk/browse/${page}` },
        { title: `Browse All Pages — Page ${page} | Garden-Review UK` },
        {
          name: "description",
          content: `Page ${page} of the Garden-Review site index: reviews, buying guides, plant guides and product pages listed A–Z.`,
        },
        {
          property: "og:title",
          content: `Browse All Pages — Page ${page} | Garden-Review UK`,
        },
        {
          property: "og:description",
          content: `Page ${page} of the full Garden-Review page index.`,
        },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: `https://www.garden-review.co.uk/browse/${page}` }],
    };
  },
  component: BrowsePageRoute,
});

function BrowsePageRoute() {
  const entries = Route.useLoaderData();
  const { page } = Route.useParams();
  return <BrowseArchive entries={entries} page={Number(page) || 1} />;
}
